import getFirstSubdomain from '../../shared-functions/DomiansplitFunction';

import postRequest from './base/post';
import BrandingService from './branding';

export default {
  /**
   * Fetch a device
   *
   * @param deviceSN
   */
  generateCheckoutId: (data = {}) => {
    const domain = getFirstSubdomain();
    const brandData = BrandingService.getCachedBranding();
    return postRequest(
      `${domain && brandData?.transactionApiUrl ? brandData?.transactionApiUrl : process.env.REACT_APP_TRANSACTION_API_URL}api/guest/v1/hyperpay-payment/generate-registration-checkout-id`,
      {
        // currency: BrandingService.getActiveCurrency(),
        currency: 'SAR',
        ...data,
      },
    );
  },
  /**
   * Fetch a device
   * @param deviceSN
   */
  generateApplePayCheckoutId: (data = {}) => {
    const domain = getFirstSubdomain();
    const brandData = BrandingService.getCachedBranding();
    return postRequest(
      `${domain && brandData?.transactionApiUrl ? brandData?.transactionApiUrl : process.env.REACT_APP_TRANSACTION_API_URL}api/guest/v1/hyperpay-payment/apple-pay/generate-registration-checkout-id`,
      {
        // currency: BrandingService.getActiveCurrency(),
        currency: 'SAR',
        ...data,
      },
    );
  },
};
